import React, { Component } from "react";
import GroupManagementSidebar from "./GroupManagementSidebar";
import {
  CreateGroupListing,
  CreateUserListing,
  RolesListing,
  BestPractices,
  CreateIIGUserListing
} from "../userManagement";
import { getLocalstorage, setLocalstorage } from "../../helper";

class GroupManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "User"
    };
  }

  handleGroupManagementActions = key => {
    this.setState({
      selectedTab: key
    });
  };
  handleNotficationflag = data => {
    this.props.onChange(data);
  };
  handleTaskID = (data, formName, toName) => {
    this.props.handleTaskID(data, formName, toName);
  };
  render() {
    const { selectedTab } = this.state;
    const { success } = this.props;
    const isUserPMG = getLocalstorage("groupCategory") === "PMG";
    return (
      <div className="workflow">
        <div className="mis-wrapper">
          <div className="mis-sidebar group-management">
            <GroupManagementSidebar
              selectedTab={selectedTab}
              handleGroupManagementActions={this.handleGroupManagementActions}
            />
          </div>
        </div>

        <div
          className={`workflow-wrapper ${selectedTab === "Draft User" &&
            "workflow-wrapper-draft"}`}
        >
          {selectedTab === "Group" ? (
            <CreateGroupListing />
          ) : (
            <React.Fragment />
          )}
          {/* <div
            className={`${!selectedTab === 'group' ? `hide-sidebar` : ""}`}
          >
            {(selectedTab.group && <CreateGroupListing />) || null}
          </div> */}
          {selectedTab === "User" ? (
            <CreateUserListing
              onNotificationChange={this.handleNotficationflag}
              handleTaskID={this.handleTaskID}
              success={success}
            />
          ) : (
            <React.Fragment />
          )}

          {selectedTab === "Draft User" ? (
            <CreateIIGUserListing />
          ) : (
            <React.Fragment />
          )}

          {/* <div
            className={`${!groupManagementActions.user ? `hide-sidebar` : ""}`}
          >
            {(groupManagementActions.user && <CreateUserListing />) || null}
          </div> */}

          {selectedTab === "Role" ? <RolesListing /> : <React.Fragment />}

          {/* {selectedTab === "Best Practices" ? (
            <BestPractices />
          ) : (
            <React.Fragment />
          )} */}
          {/* <div
            className={`${!groupManagementActions.role ? `hide-sidebar` : ""}`}
          >
            {(groupManagementActions.role && <RolesListing />) || null}
          </div>*/}
        </div>
      </div>
    );
  }
}

export default GroupManagement;
